// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as URLUtils$Showside from "../utils/URLUtils.bs.js";
import * as DataAttribute$Showside from "../utils/DataAttribute.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
function Link(Props) {
  var children = Props.children;
  var href = Props.href;
  var title = Props.title;
  var fwdRef = Props.fwdRef;
  var disabledOpt = Props.disabled;
  var unstyledOpt = Props.unstyled;
  var underlineOpt = Props.underline;
  var accentOpt = Props.accent;
  var classNameOpt = Props.className;
  var textSizeOpt = Props.textSize;
  var style = Props.style;
  var role = Props.role;
  var ariaLive = Props.ariaLive;
  var ariaLabel = Props.ariaLabel;
  var openLinkInNewTabOpt = Props.openLinkInNewTab;
  var data = Props.data;
  var dataTestId = Props.dataTestId;
  var dataCount = Props.dataCount;
  var dataDisabled = Props.dataDisabled;
  var onClick = Props.onClick;
  var onMouseOverOpt = Props.onMouseOver;
  var onMouseLeaveOpt = Props.onMouseLeave;
  var tabIndexOpt = Props.tabIndex;
  var icon = Props.icon;
  var disabled = disabledOpt !== undefined ? disabledOpt : false;
  var unstyled = unstyledOpt !== undefined ? unstyledOpt : false;
  var underline = underlineOpt !== undefined ? underlineOpt : false;
  var accent = accentOpt !== undefined ? accentOpt : true;
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var textSize = textSizeOpt !== undefined ? textSizeOpt : /* Xl */2;
  var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
  var onMouseOver = onMouseOverOpt !== undefined ? onMouseOverOpt : function (param) {};
  var onMouseLeave = onMouseLeaveOpt !== undefined ? onMouseLeaveOpt : function (param) {};
  var tabIndex = tabIndexOpt !== undefined ? tabIndexOpt : 0;
  ViewportContext$Showside.use(undefined);
  var match = EntrypointContext$Showside.use(undefined);
  var redirectToLink = match.redirectToLink;
  var href$1 = Belt_Option.map(href, URLUtils$Showside.maybeMakeRelativeUrl);
  var role$1 = role !== undefined ? role : href$1 !== undefined ? "link" : "button";
  var tmp;
  if (unstyled) {
    tmp = "";
  } else {
    switch (textSize) {
      case /* Base */0:
        tmp = CSS$Showside.prefix("text-base");
        break;
      case /* Lg */1:
        tmp = CSS$Showside.prefix("text-lg");
        break;
      case /* Xl */2:
        tmp = CSS$Showside.prefix("text-xl");
        break;
    }
  }
  var className$1 = Cn.make([unstyled ? "" : CSS$Showside.prefix("inline-block whitespace-nowrap dark-hover darker-active cursor-pointer"), unstyled ? "" : accent ? CSS$Showside.prefix("!text-accent") : CSS$Showside.prefix("!text-primary"), tmp, unstyled ? "" : underline ? CSS$Showside.prefix("underline") : CSS$Showside.prefix("!no-underline hover:underline"), Belt_Option.isSome(icon) ? CSS$Showside.prefix("flex") : "", CSS$Showside.prefix("font-button"), className]);
  var onClick$1 = function (e) {
    e.preventDefault();
    Belt_Option.forEach(onClick, function (cb) {
      Curry._1(cb, e);
    });
    if (href$1 !== undefined && !disabled) {
      return Curry._5(redirectToLink, undefined, undefined, undefined, openLinkInNewTab, href$1);
    }
  };
  var tmp$1 = {
    className: className$1,
    draggable: false,
    role: role$1,
    tabIndex: tabIndex,
    onClick: onClick$1,
    onMouseLeave: onMouseLeave,
    onMouseOver: onMouseOver
  };
  if (fwdRef !== undefined) {
    tmp$1.ref = Caml_option.valFromOption(fwdRef);
  }
  if (ariaLabel !== undefined) {
    tmp$1["aria-label"] = Caml_option.valFromOption(ariaLabel);
  }
  if (style !== undefined) {
    tmp$1.style = Caml_option.valFromOption(style);
  }
  if (title !== undefined) {
    tmp$1.title = Caml_option.valFromOption(title);
  }
  if (data !== undefined) {
    tmp$1.data = Caml_option.valFromOption(data);
  }
  if (href$1 !== undefined) {
    tmp$1.href = Caml_option.valFromOption(href$1);
  }
  var tmp$2 = {
    children: React.createElement("a", tmp$1, Belt_Option.mapWithDefault(icon, null, function (icon) {
      return React.createElement("div", {
        className: CSS$Showside.prefix("mr-2")
      }, icon);
    }), children)
  };
  if (dataDisabled !== undefined) {
    tmp$2.dataDisabled = Caml_option.valFromOption(dataDisabled);
  }
  if (dataTestId !== undefined) {
    tmp$2.dataTestId = Caml_option.valFromOption(dataTestId);
  }
  if (dataCount !== undefined) {
    tmp$2.dataCount = Caml_option.valFromOption(dataCount);
  }
  if (ariaLive !== undefined) {
    tmp$2.ariaLive = Caml_option.valFromOption(ariaLive);
  }
  return React.createElement(DataAttribute$Showside.make, tmp$2);
}
Link.displayName = "Link";
var make = Link;
export { make };
/* react Not a pure module */